import { createFileRoute } from "@tanstack/react-router";
import { SITE_URL } from "@/lib/utils";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service — Pluggz" },
      { name: "description", content: "Terms governing use of the Pluggz creator marketplace." },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/terms` }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <article className="mx-auto max-w-3xl px-6 py-16 prose prose-neutral">
      <h1 className="font-serif text-4xl">Terms of Service</h1>
      <p className="text-sm text-muted-foreground">Last updated: 2026-01-15</p>
      <h2>1. Accounts</h2>
      <p>You are responsible for keeping your credentials secure and for activity on your account.</p>
      <h2>2. Creator program</h2>
      <p>Creators earn commissions on qualifying affiliate sales attributed to their links. Commissions are paid net of returns and fraud adjustments.</p>
      <h2>3. Acceptable use</h2>
      <p>No spam, click fraud, impersonation, or unlawful content. We may suspend accounts that violate these rules.</p>
      <h2>4. Liability</h2>
      <p>Pluggz is provided "as is" without warranties. Our liability is limited to the fees you have paid us in the prior 12 months.</p>
      <h2>5. Governing law</h2>
      <p>These terms are governed by the laws of England and Wales.</p>
    </article>
  );
}
